import { Component, EmbeddedViewRef, Inject, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { LoginService } from '../login.service';
import { ExamsService } from '../exams.service';
import { PatientsService } from '../patients.service';
import { Patient } from '../patients/patient';
import { Subject, Subscription } from 'rxjs';
import * as XLSX from 'xlsx';
import { takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';


@Component({
    selector: 'app-docpanel',
    templateUrl: './docpanel.component.html',
    styleUrls: ['./docpanel.component.scss'],
    standalone: false
})
export class DocpanelComponent implements OnInit, OnDestroy {
  showLogin = false;
  sub = new Subscription();
  private destroy$ = new Subject();
  showLimits = false;
  currentApplicationVersion: string;
  currentAppDate: string;
  // The About popup is aweb's t-popup, but its nodes are moved to document.body while it is open.
  // Rendered in place it sat inside the exam sidebar (.l-sidebar is position:fixed, so its own
  // stacking context): the exam content painted over it and its close button could not be
  // clicked. The view stays attached to this component, so bindings keep updating, and destroy()
  // removes the nodes from wherever they are.
  @ViewChild('aboutTpl') aboutTpl: TemplateRef<any>;
  private aboutView: EmbeddedViewRef<any> | null = null;


  constructor(private http:HttpClient,public loginService: LoginService, public patS: PatientsService, private es: ExamsService,
    private vcr: ViewContainerRef, @Inject(DOCUMENT) private document: Document) { }

  openAbout() {
    if (this.aboutView) return;
    this.aboutView = this.vcr.createEmbeddedView(this.aboutTpl);
    for (const node of this.aboutView.rootNodes) this.document.body.appendChild(node);
  }

  closeAbout() {
    this.aboutView?.destroy();
    this.aboutView = null;
  }

  ngOnInit() {
    this.currentApplicationVersion = environment.appVersion;
    this.currentAppDate = environment.versionDate;
    this.sub = this.loginService.export$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data) {
        this.export(data);
      }
    })
  }

  goDefaults() {
    let defaults = new Patient("default", "default", "defaults", "defaults");
    defaults.PID = 0;
    this.patS.setPat(defaults, true);
  }

  // Redirect into the admin app (awebAppointments) for the given module — mirrors
  // patients.component.ts. Moved here so the questionnaires entry lives in Settings.
  redirectAdministration(type) {
    this.http.post("/api/administration", { type }).subscribe((data: string) => {
      window.location.href = data;
    });
  }

  export(res) {
    this.sub = res.subscribe((data) =>{
      var element = document.createElement('a');
      // window.open('/api/stats/exportData')
      element.setAttribute('href','/api/stats/readydata');
      element.setAttribute('download', './test.csv');
      document.body.appendChild(element);
      element.click();
      setTimeout(() => {
        document.body.removeChild(element);
      },4000 );
      
      this.loginService.exportLoading = false;
      this.showLogin = false;
      
    })
  }

  logout(){
    this.loginService.clearCookies();
    this.loginService.Logout();
    
  }


  ngOnDestroy(): void {
    this.closeAbout();
    this.sub.unsubscribe();
    this.destroy$.next(undefined);
  }

}
